module.exports = __webpack_public_path__ + "static/portfolio1-6d472fb9e512fbe40e16445b77a676be.png";